import React, { useMemo } from 'react';

import Highlighter from '@components/HighlightWords';
import { ProjectAvatar } from '@components/ProjectCard/ProjectAvatar';
import Icon from '@components/shared/Icon/Icon';
import useColors from '@hooks/useColors';
import { ProjectTagType } from '@src/types/project';
import theme from '@themes/theme';

import { Box, Text } from '../Restyle';

export interface ProjectTagProps {
  project: ProjectTagType;
  filterVal?: string;
  isFrom?: string;
  isMember?: boolean;
}

export const ProjectTag = ({
  project,
  filterVal = '',
  isFrom,
  isMember,
}: ProjectTagProps) => {
  const { name, color, team } = project;
  const { getMappedColor } = useColors();
  const isPersonalProject = team?.personal ?? false;

  const renderIcon = useMemo(() => {
    return (
      <ProjectAvatar
        hideInitial
        icon='TTProject'
        color={getMappedColor(color)}
        dimensions={{
          width: 12,
          height: 12,
        }}
        personal={isPersonalProject}
      />
    );
  }, []);

  const renderHighlighter = useMemo(() => {
    return (
      <Highlighter
        autoEscape
        highlightStyle={{
          color: theme.colors.black,
          fontFamily: 'Inter_600SemiBold',
          backgroundColor: theme.colors.yellowBright,
        }}
        searchWords={filterVal?.split(' ') || ''}
        textToHighlight={name}
      />
    );
  }, [filterVal]);

  return (
    <Box flexDirection='row' alignItems='center'>
      {isFrom === 'Chat' ? <Icon name='TTProject' variant='m' /> : renderIcon}
      <Box
        flex={1}
        marginLeft='xs'
        justifyContent='center'
        alignContent='center'
        marginBottom='xxxs'>
        <Text
          accessibilityLabel='Highlighter'
          variant={isMember ? 'labelEmphasized' : 'labelEmphasizedDisabled'}
          numberOfLines={1}
          lineHeight={21}>
          {renderHighlighter}
        </Text>
      </Box>
    </Box>
  );
};
